import { render, staticRenderFns } from "./OverviewFive.vue?vue&type=template&id=080cc2da&"
import script from "./OverviewFive.vue?vue&type=script&lang=js&"
export * from "./OverviewFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports